<template>
  <div class="c-nav">
    <div>
    <div class="cover" v-show="toggle" @click="menuClick" @touchmove.prevent @mousewheel.prevent></div>
    <div class="container navFlex">
      <a class="flexItem logobox" href="/">
        <img class="logo" :src="require('../assets/img/logo.png')" />
      </a>
      <div class="flexItem hiden" :class="toggle?'goRotate':'backRotate'">
        <img class="btnImg" :src="require('../assets/menu' + menuButtonSrc + '.png')" @click="menuClick"/>
      </div>
           <div class="flexItem menubody" :class="selected==0?'colorWhite':'colorGold'" v-show="toggle" ref="menuBody" @touchmove.prevent>
              <ul>
                <li><a class="menuOne" href="/" :class="selected==0?'selected':''">首页</a></li>
                <li v-if="false" @mouseenter="showClassDetail" @mouseleave="hideClassDetail">
                  <a class="menuOne" href="javascript:void(0)" @click="notClassToggl(classToggle)" :class="selected==1?'selected':''">课程介绍<img class="down" :class="classToggle?'goRotate180':'backRotate'" :src="require('../assets/down.png')"/></a>
                  <ul v-show="classToggle" class="classDetail">
                    <li @mouseenter="showAuClassDetail" @mouseleave="hideAuClassDetail" @click="notAuClassToggl(AuClassToggle)">
                      <a class="menuTwo" href="#">澳洲校区课程<img class="down" :class="AuClassToggle?'goRotate180':'backRotate'" :src="require('../assets/down.png')"/></a>
                      <ul v-show="AuClassToggle" class="classDetailThree">
                        <li><a class="menuTwo" href="/macquarie">麦考瑞课程</a></li>
                        <li><a class="menuTwo" href="/monash">Monash课程</a></li>
                        <li><a class="menuTwo" href="/UNSW">UNSW和USYD</a></li>
                      </ul>
                    </li>
                    <li @mouseenter="showEnClassDetail" @mouseleave="hideEnClassDetail" @click="notEnClassToggl(EnClassToggle)">
                      <a class="menuTwo" href="#">英国校区课程<img class="down" :class="EnClassToggle?'goRotate180':'backRotate'" :src="require('../assets/down.png')"/></a>
                      <ul v-show="EnClassToggle" class="classDetailThree enClassDetail">
                        <li><a class="menuTwo" href="/manchester">曼彻斯特大学</a></li>
                        <li><a class="menuTwo" href="/kingsLondon">英国伦敦国王学院</a></li>
                        <li><a class="menuTwo" href="/holloway">英国皇家霍洛威</a></li>
                      </ul>
                    </li>
                    <li><a class="menuTwo" href="/CPA">澳洲CPA课程</a></li>
                    <li><a class="menuTwo" href="/CFA">CFA Program课程</a></li>
                    <li><a class="menuTwo" href="/accounting">会计实战课程</a></li>
                    <li><a class="menuTwo" href="/PTE">PTE语言培训</a></li>
                    <li><a class="menuTwo" href="/IELTS">雅思托福保过班</a></li>
                    <li><a class="menuTwo" href="/G5">藤校/G5直推班</a></li>
                  </ul>
                </li>
                <li>
                  <a class="menuOne" href="/course"  :class="selected==2?'selected':''" target="_blank">精培网校</a>
                </li>
                <li><a class="menuOne" href="/team" :class="selected==7?'selected':''">名师团队</a></li>
                <li @mouseenter="showCollegaDetail" @mouseleave="hideCollegaDetail" @click="notCollegaToggl">
                  <a class="menuOne" href="javascript:void(0)" :class="selected==3?'selected':''">校园新闻<img class="down" :class="collegaToggle?'goRotate180':'backRotate'" :src="require('../assets/down.png')"/></a>
                  <ul v-show="collegaToggle" class="classDetail">
                    <li><a class="menuTwo" href="/auNews">澳洲校区新闻</a></li>
                    <li><a class="menuTwo" href="/enNews">英国校区新闻</a></li>
                  </ul>
                </li>
                <li v-if="false"><a class="menuOne" href="/induction" :class="selected==4?'selected':''">实习全职</a></li>
                <li v-if="false" @mouseenter="showStudyDetail" @mouseleave="hideStudyDetail" @click="notStudyToggl">
                  <a class="menuOne" href="javascript:void(0)" :class="selected==5?'selected':''">升学转学<img class="down" :class="studyToggle?'goRotate180':'backRotate'" :src="require('../assets/down.png')"/></a>
                  <ul v-show="studyToggle" class="classDetail">
                    <li><a class="menuTwo" href="/transfer">免费升转学</a></li>
                    <li><a class="menuTwo" href="/ivyLeague">美国藤校/英国G5保录</a></li>
                  </ul>
                </li>
                <li><a class="menuOne" href="/aboutUs" :class="selected==6?'selected':''">联系我们</a></li>
        </ul>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderMain",
  data () {
    return {
      msg : "头部菜单栏",
      toggle : false,
      screenWidth : 0,
      menuButtonSrc : 1,
      classToggle : false,
      collegaToggle : false,
      studyToggle : false,
      AuClassToggle : false,
      EnClassToggle : false,
      searchMsg:this.$route.params.searchMsg,
      loginToggle: true,
      userName: ''
    }
  },
  props:{
    selected:String
  },
  created() {
    this.screenWidth = document.body.clientWidth;
    if(this.screenWidth < 800){
      this.toggle = false;
    }else{
      this.toggle = true;
    }
  },
  mounted () {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        if(window.screenWidth < 700){
          that.toggle = false;
        }else{
          that.toggle = true;
        }
      })()
    }
  },
  methods : {
    menuClick () {
      this.toggle = !this.toggle;
      this.menuButtonSrc = this.toggle?2:1;
    },
    showClassDetail () {
      if(this.screenWidth >= 700){
        this.classToggle = true;
      }
    },
    hideClassDetail () {
      console.log("hideClassDetail")
      this.classToggle = false;
    },
    notClassToggl ( value ) {
      console.log("notClassToggl")
      this.classToggle = !this.classToggle;
    },
    showCollegaDetail () {
      if(this.screenWidth >= 700){
        this.collegaToggle = true;
      }
    },
    hideCollegaDetail () {
      this.collegaToggle = false;
    },
    notCollegaToggl () {
      this.collegaToggle = !this.collegaToggle;
    },
    showStudyDetail () {
      if(this.screenWidth >= 700){
        this.studyToggle = true;
      }
    },
    hideStudyDetail () {
      this.studyToggle = false;
    },
    notStudyToggl () {
      this.studyToggle = !this.studyToggle;
    },
    showAuClassDetail () {
      if(this.screenWidth >= 700){
        this.AuClassToggle = true;
      }
    },
    hideAuClassDetail () {
      this.AuClassToggle = false;
    },
    notAuClassToggl ( value ) {
      this.AuClassToggle = !this.AuClassToggle;
    },
    showEnClassDetail () {
      if(this.screenWidth >= 700){
        this.EnClassToggle = true;
      }
    },
    hideEnClassDetail () {
      this.EnClassToggle = false;
    },
    notEnClassToggl ( value ) {
      this.EnClassToggle = !this.EnClassToggle;
    },
  }
}
</script>
<style scoped>
  .tempBody a{
    color: #a8aaba;
    display: inline-block;
    padding: 10px 10px 10px 10px;
    font-size: 20px;
  }
  *{
    margin:0;
    padding:0;
    list-style-type:none;
    border: none;
  }
  a{
    text-decoration: none;
  }
  .container{
    padding: 0 !important;
    max-width:1140px;
    margin:0 auto;
    border: none !important;
  }
  .c-nav .menubody{ display:inline-block; z-index: 999;}
  .c-nav .hiden{ display:none; }
  /* 导航栏 */
  .c-nav{
    width:100%;
    box-shadow: 0 0 25px 0 #7677799e;
    background-color: rgba(255, 255, 255, 0.2);
    /*background-color: #999a9d;*/}
  .c-nav .navFlex{
    display:flex;
    display:-webkit-flex;
    justify-content:space-between;
    -webkit-justify-content:space-between;
    align-items:center;
    -webkit-align-content:center;
    color: #767779;}
  .c-nav ul{
    list-style:none;
    text-align: left;
    margin-bottom:0px;
    padding-left:0px;}
  .c-nav ul li{
    padding:15px 0px 15px 0px;
    margin-left:30px;
    display:inline-block;}
  .colorWhite a{
    color: #FFFFFF;
  }
  .colorGold a{
    color: #e4c17e;
  }
  .c-nav ul li a.menuOne{

    font-style: normal;

    padding-bottom:2px;
    text-decoration:none;
    border-bottom:3px solid transparent;}
  .c-nav ul li a:hover{
    border-bottom:3px solid #e4c17e;}
  .c-nav ul li a.selected{
    border-bottom:3px solid #e4c17e;
  }
  .c-nav .logobox{
    z-index: 999;
  }
  .c-nav .logo{ height:80px;}
  .c-nav .btnImg{
    height:30px;
    padding:3px 20px 3px 20px;
    box-sizing:content-box;
    border:1px solid transparent;}
  .down{
    height : 15px;
    box-sizing:content-box;
    position: relative;
    top: 2px;
    left: 3px;
  }
  .classDetail{
    position: absolute;
    opacity: 1;
    background-color: white;
    width: 210px;
    box-shadow: 0px 3px 3px rgb(0 0 0 / 30%) !important;
    z-index: 10;
  }
  .classDetailThree{
    position: absolute;
    opacity: 1;
    background-color: white;
    width: 210px;
    box-shadow: 0px 3px 3px rgb(0 0 0 / 30%) !important;
    left: 150px;
    z-index: 20;
  }
  .classDetail li{
    line-height: 10px;
    width: 90%;
    padding: 20px 0 20px 0px !important;
    margin-left: 0 !important;
  }
  .classDetail li a.menuTwo{
    color:black;
    font-style: normal;
    font-size: 15px;
    padding-bottom:2px;
    text-decoration:none;
    border-bottom:3px solid transparent;
    margin-left: 40px;
  }
  /*实现自旋功能*/
  .goRotate{
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transition: all 0.5s;
  }
  .goRotate180{
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transition: all 0.5s;
  }
  .backRotate{
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transition: all 0.5s;
  }

  @media screen and (max-width:700px){
    .flexItem{
      z-index: 999;
    }
    .cover{
      width: 100%;
      height: 100%;
      z-index: 998;
      background-color: #767779;
      display: block;
      position: fixed;
      top: 85px;
      opacity:0.7;
    }
    .c-nav{
      padding:10px 0px 10px 0px;
      z-index: 10;}
    .c-nav .navFlex{flex-wrap:wrap;font-size:20px;justify-content:space-between;}
    .c-nav .logo{height:60px;padding-left: 20px;}
    .c-nav ul li{padding-top:10px;margin-left:0px;display:block;}
    .c-nav ul li a{border-bottom:3px solid transparent;}
    .c-nav ul a:hover{border-bottom:3px solid #e4c17e;}
    .c-nav ul li:nth-child(4),.c-nav ul li:nth-child(5){display:block;}
    .c-nav .hiden{display:block;}
    .c-nav ul li a.menuOne{
      margin-left: 20px;
    }
    .c-nav .menubody{
      background-color: white;
      width:100%;
      font-size:16px;
      z-index: 999;}
    .classDetail{
      position: absolute;
      opacity: 1;
      background-color: white;
      width: 210px;
      left: 100px;
      box-shadow: 0px 3px 3px rgb(0 0 0 / 30%) !important;
    }
    .classDetailThree{
      left: 0;
      top: 50px;
      box-shadow: 0px 0px 3px rgb(0 0 0 / 30%) !important;
    }
    .enClassDetail{
      top: 105px;
    }
    .c-nav ul li a.menuOne{
      color: #e4c17e;
    }
    .c-nav ul li .menuTwo{
      color: #e4c17e;
    }
  }

  @media screen and (max-width:500px){
    .login{
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .c-nav{
      padding:10px 0px 0px 0px;
    }
    .c-nav .logo{
      padding-left: 0;
      margin-bottom: 0;
    }
    .searchBox {
      width: 120px;
    }
    .searchInput{
      width: 80px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderMain.vue